import moment from 'moment'

export const PatientOrthoDiagnose = {
    id: '',
    patientId: '',
    patientName: '',
    patientAddress: '',
    patientAge: 0,
    clarificationL: 0,
    clarificationR: 0,
    profile: 0,
    agnesisTL: 0,
    agnesisTR: 0,
    agnesisBL: 0,
    agnesisBR: 0,
    impactedTL: 0,
    impactedTR: 0,
    impactedBL: 0,
    impactedBR: 0,
    complaint: '',
    missingTL: 0,
    missingTR: 0,
    missingBL: 0,
    missingBR: 0,
    abnormalities: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}